import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import classNames from 'classnames';

import {Routing} from 'nutshell-core/routing';

import type {EntitySummaryRating} from 'nutshell-graphql-types';

import {BulletedList} from '../../bulleted-list/bulleted-list';
import {colors} from '../../colors/colors';
import {SquareArrowRightRegularIcon} from '../../icon/svg/square-arrow-right-regular-icon';
import {TextRegularAiIcon} from '../../icon/svg/text-regular-ai-icon';
import {Stack} from '../../layout/stack/stack';
import {Link} from '../../link/link';
import {Footer} from '../../summary/footer';
import {Body} from '../../typography/body';
import {SectionLabel} from '../../typography/section-label';

type Props = {
    recap: string;
    nextSteps: string[];
    hasPadding?: boolean;
    userRating?: EntitySummaryRating | null | undefined;
    onRate?: (rating: EntitySummaryRating) => Promise<any>;
    isSavingRating?: boolean;
    onRefresh?: () => Promise<any>;
    onFeedback?: () => void;
    entityId?: string;
    // Allows us to apply some special layout for the widget variant of this
    // component
    isWidget?: boolean;
    onLearnMore?: () => void;
};

export function LeadSummary(props: Props) {
    const {recap, nextSteps, hasPadding = true} = props;

    const containerClass = classNames({
        'px-16': hasPadding,
    });

    return (
        <div className={containerClass}>
            <Stack spacing={8}>
                {recap && (
                    <div className='pb-8'>
                        {!props.isWidget && (
                            // @ts-expect-error
                            <Stack isHorizontal={true} spacing={4} alignCenter={true}>
                                <TextRegularAiIcon
                                    // @ts-expect-error
                                    color={colors.aiPurplePrimary}
                                    fill={colors.aiPurplePrimary}
                                    size={20}
                                    alignCenter={true}
                                />
                                <SectionLabel color='ai-purple' noBottomBorder={true}>
                                    Recap
                                </SectionLabel>
                            </Stack>
                        )}
                        <Body maintainLineBreaks={true}>{recap}</Body>
                    </div>
                )}
                {nextSteps && (
                    <div className='pb-8'>
                        {/* @ts-expect-error */}
                        <Stack isHorizontal={true} spacing={4} alignCenter={true}>
                            <SquareArrowRightRegularIcon
                                // @ts-expect-error
                                color={colors.aiPurplePrimary}
                                fill={colors.aiPurplePrimary}
                                size={20}
                                alignCenter={true}
                            />
                            <SectionLabel color='ai-purple' noBottomBorder={true}>
                                Next Steps
                            </SectionLabel>
                        </Stack>
                        <div className='pl-8'>
                            <BulletedList
                                bullets={nextSteps}
                                lessSpacing={true}
                                marginBottom={8}
                                greyBullets={true}
                            />
                        </div>
                    </div>
                )}
                {NutClientConfig.hasAiDebugging && props.entityId && (
                    <div className='pb-8'>
                        <Link
                            variant='button-secondary'
                            to={`/ai/lead-summary?${Routing.param({
                                id: props.entityId,
                            })}`}
                            newTab={true}
                            // @ts-expect-error
                            as={RoutedLink}
                        >
                            🏗️ Internal AI playground
                        </Link>
                    </div>
                )}
                <Footer
                    userRating={props.userRating}
                    onRate={props.onRate}
                    isSavingRating={props.isSavingRating}
                    onRefresh={props.onRefresh}
                    onFeedback={props.onFeedback}
                    onLearnMore={props.onLearnMore}
                />
            </Stack>
        </div>
    );
}
